var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 24c6.627 0 12-5.373 12-12s-5.373-12-12-12C5.972 0 .6 5.373.6 12s5.372 12 12 12zm5.503-15.578a5.968 5.968 0 001.697-.458 5.963 5.963 0 01-1.475 1.506c.005.125.008.25.008.376 0 3.845-2.97 8.279-8.405 8.279A8.458 8.458 0 015.4 16.818c.231.027.466.04.705.04a5.983 5.983 0 003.669-1.245 2.952 2.952 0 01-2.76-2.021 3.05 3.05 0 001.334-.05c-1.352-.267-2.37-1.443-2.37-2.853v-.036c.399.217.854.348 1.338.363a2.896 2.896 0 01-1.313-2.42c0-.535.145-1.034.399-1.464a8.43 8.43 0 006.09 3.04 2.901 2.901 0 01-.077-.663c0-1.606 1.322-2.909 2.954-2.909.85 0 1.617.353 2.156.92a5.979 5.979 0 001.876-.707c-.22.68-.688 1.25-1.298 1.61z",
    fill: "#000"
  })));
}

export default SvgTwitterIconDark;